import { render, staticRenderFns } from "./UserInteractionButtons.vue?vue&type=template&id=ee061f52"
import script from "./UserInteractionButtons.vue?vue&type=script&lang=js"
export * from "./UserInteractionButtons.vue?vue&type=script&lang=js"
import style0 from "./UserInteractionButtons.vue?vue&type=style&index=0&id=ee061f52&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports